import { useMoodBooster } from '@/hooks/useMoodBooster';
import { Switch } from '@/components/ui/switch';
import { cn } from '@/lib/utils';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip';

interface MoodBoosterProps {
  collapsed?: boolean;
}

export function MoodBooster({ collapsed = false }: MoodBoosterProps) {
  const { isPlaying, toggle } = useMoodBooster();

  if (collapsed) {
    return (
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            onClick={toggle}
            className={cn(
              "w-full h-10 flex items-center justify-center rounded-md transition-colors",
              "hover:bg-sidebar-accent/50 text-sidebar-foreground",
              isPlaying && "text-primary"
            )}
            aria-label="Toggle Mood Booster"
          >
            <span className="text-base">🎧</span>
          </button>
        </TooltipTrigger>
        <TooltipContent side="right">
          <div className="text-xs">
            <p className="font-medium">Mood Booster</p>
            <p className="text-muted-foreground">Focus • Coffee Shop</p>
          </div>
        </TooltipContent>
      </Tooltip>
    );
  }

  return (
    <button
      onClick={toggle}
      className={cn(
        "w-full flex items-center justify-between gap-3 px-3 h-10 rounded-md transition-colors",
        "hover:bg-sidebar-accent/50 text-sidebar-foreground"
      )}
    >
      <div className="flex items-center gap-2.5 min-w-0">
        <span className="text-sm flex-shrink-0">🎧</span>
        <div className="flex flex-col items-start min-w-0">
          <span className="text-xs font-medium truncate">Mood Booster</span>
          <span className="text-[10px] text-muted-foreground truncate">Focus • Coffee Shop</span>
        </div>
      </div>
      <Switch
        checked={isPlaying}
        onCheckedChange={toggle}
        className="flex-shrink-0 scale-75 origin-right"
        onClick={(e) => e.stopPropagation()}
      />
    </button>
  );
}
